/* override */
import React from 'react';
import { pure } from 'recompose';
import { Image } from 'js/components/common/Image';
import { Link } from 'js/components/common/Link';
import { Button } from 'js/components/common/Button';
import { Jackpot } from 'js/components/main/Games/Jackpot';
import { useGameConfigurationSelector } from 'js/store/hooks';
import { usePortletSelector } from 'js/components/system/Portlet';
import { useLiveGameConfig, useGameImageUrls } from 'js/hooks/games';
import { FavoriteIcon } from 'js/components/common/Game/FavoriteIcon';
import { withTranslations } from 'js/components/hocs/withTranslations';
import { compose, path, pick, pipe, prop } from 'ramda';

import { PlayButton } from 'js/components/main/Games/Buttons';

import style from './index.scss';

export const HoveredGame = ({
    t,
    code,
    gameImageUrl,
    setGameInfoRef,
    showFavoriteIcon
}) => {
    const gameFeed = usePortletSelector(prop('feedName'));
    const { name, liveLaunchAlias } = useGameConfigurationSelector(pipe(
        path(['games', code]),
        pick(['name', 'liveLaunchAlias'])
    ));
    const liveGameConfig = useLiveGameConfig(liveLaunchAlias);
    const isLiveGame = liveGameConfig?.launchAlias;
    const { dynamicImageUrl, limits, openingDateTime, isScheduled } = liveGameConfig || {};
    const isScheduledLiveGame = isLiveGame && isScheduled;
    const imageUrls = useGameImageUrls({ code, dynamicImageUrl, isLiveGame });

    return (
        <div ref={setGameInfoRef} className={style.gameInfoContainer}>
            <div className={style.flip}>
                <div className={style.front}>
                    <Image
                        className={style.image}
                        src={gameImageUrl || imageUrls}
                    />
                    <div className={`${isScheduledLiveGame ? style.scheduledLiveGameBackground : style.gameBackground}`} />
                    <div className={style.gameContent}>
                        <h2 className={style.title}>{name}</h2>
                        <div className={style.buttons}>
                            <Link href={`/online-game/${code}`} className={style.infoLink}>
                                <Button
                                    color="info"
                                    className={style.infoBtn}
                                >
                                    {t('playtech.mobile.system.game.info.button')}
                                </Button>
                            </Link>
                            {isScheduledLiveGame
                                ? (
                                    <div className={style.scheduledLiveGameInfo}>
                                        {openingDateTime
                                            ? (
                                                <>
                                                    <span>{t('playtech.mobile.system.liveGame.startsAt')}</span>
                                                    <span>{openingDateTime}</span>
                                                </>
                                            )
                                            : <span>{t('playtech.mobile.system.liveGame.startsSoon')}</span>
                                        }
                                    </div>
                                )
                                : <PlayButton
                                    code={code}
                                    name={name}
                                    isHoverBtn={true}
                                    className={style.playBtn}
                                />
                            }
                        </div>
                        <div className={style.bottomIcons}>
                            {isLiveGame && limits && <div className={style.liveLimits}>{limits}</div>}
                            {showFavoriteIcon && (
                                <FavoriteIcon
                                    code={code}
                                    gameFeed={gameFeed}
                                    className={style.favorite}
                                />
                            )}
                        </div>
                        <Jackpot
                            gameCode={code}
                            className={style.jackpot}
                            showGuaranteedHitTime={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default compose(
    pure,
    withTranslations
)(HoveredGame);
